<template>
	<cm-lightbox v-if="lightboxCallbackVisible" @lgbcancel="onCancel">
		<template v-slot:header>{{ lightbox?.header }}</template>

		<template v-slot:body>
			<div class="lightbox__block" v-for="(block, index) in lightbox.body" :key="index" :data-kind="block.kind">
				<div class="lightbox__title">{{ block.title }}</div>

				<cm-input
					:type="'tel'"
					:mask="'phone'"
					:name="block.name"
					:value="block.value"
					:status="block.status"
					:disabled="block.disabled"
					@iptinput="onChange($event, 'input')"
					@paste="onChange($event, 'input')"
					@iptchange="onChange($event, 'input')"
					@blur="onChange($event, 'input')"
				/>
			</div>
		</template>

		<template v-slot:footer>
			<cm-button type="text" value="Заказать звонок" paint="blue" :disabled="!validation" @click="onApply" />
		</template>
	</cm-lightbox>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from "vuex";

	import Lightbox from "../appearance/Lightbox.vue";
	import Button from "../components/Button.vue";
	import Input from "../components/Input.vue";

	export default {
		components: {
			"cm-button": Button,
			"cm-input": Input,
			"cm-lightbox": Lightbox,
		},
		data() {
			return {
				loading: false,
				lightbox: null,
				validation: false,
			};
		},
		computed: {
			...mapGetters({
				lightboxCallbackVisible: "lightboxCallbackVisible",
				about: "getProfileAbout",
			}),
			state() {
				return this.$store.state;
			},
		},
		methods: {
			...mapMutations(["showLightboxCallback"]),
			...mapActions(["getCommonCallback"]),

			/* INIT FUNCTIONS */
			initLightbox() {
				if (this.about?.phone?.value) {
					this.lightbox = {
						header: "Связь с техподдержкой",
						body: [
							{
								id: 0,
								kind: "file",
								name: "phone",
								title: "Телефон для связи",
								value: this.about.phone.value,
								status: "valid",
								error: false,
							},
						],
					};

					this.validation = true;
				} else {
					this.lightbox = {
						header: "Связь с техподдержкой",
						body: [
							{
								id: 0,
								kind: "file",
								name: "phone",
								title: "Телефон для связи",
								value: null,
								status: "default",
								error: false,
							},
						],
					};
				}
			},

			/* SPECIAL HANDLERS */
			nandleInput(payload) {
				let input = this.lightbox.body[0];

				if (input) {
					input.value = payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						input.status = "valid";
						input.error = null;
					} else {
						input.status = "invalid";
						input.error = this.state.common.errors[payload.name];
					}
				}
			},
			checkValidation() {
				if (this.lightbox.body?.length) {
					this.validation = this.lightbox.body.every((element) => {
						return element.status == "valid";
					});
				}
			},

			/* EVENT HANDLERS */
			onChange(event, source) {
				let payload = null;

				if (source === "input") {
					payload = {
						name: event.target.name,
						value: event.target.value,
						event: event.type,
					};

					this.nandleInput(payload);
				}

				this.checkValidation();
			},
			onCancel() {
				this.showLightboxCallback(false);
				this.onReset();
			},
			onApply() {
				let payload = {};

				this.lightbox.body.forEach((item) => {
					payload[item.name] = item.value;
				});

				this.getCommonCallback(payload);
				this.showLightboxCallback(false);
				this.onReset();
			},
			onReset() {
				if (this.lightbox.body?.length) {
					this.lightbox.body.forEach((element) => {
						element.value = null;
						element.status = "default";
						element.error = false;
					});
				}

				this.validation = false;
			},
		},
		watch: {
			lightboxCallbackVisible: function (newVal) {
				if (newVal) this.initLightbox();
			},
		},
	};
</script>

<style lang="scss" scoped></style>
